<app-smartsupp [username]="smartsuppUsername" [name]="localUser.name"></app-smartsupp>
<div *ngIf="onlineTeachers" class="container">

  <div class="login-container">
    <div class="row no-gutters">
      <div class="col-6 d-flex flex-column p-3">
        <div *ngIf="noAccessWarning" class="alert alert-danger error font-size-12 px-3 py-1">
          {{noAccessWarning}}
        </div>
        <h3 class="title"><span>Welcome</span> {{localUser | fullName}}</h3>
        <p class="font-size-12 mb-3">Please select your role:</p>

        <div *ngIf="teachersWarning" class="alert alert-danger error font-size-12 px-3 py-1">
          {{teachersWarning}}
        </div>

        <form (ngSubmit)="selectAccessType()" [formGroup]="form">
          <div class="form-group">
            <select class="form-control" formControlName="selectedRoleType">
              <option *ngFor="let accessType of accessTypes" [ngValue]="accessType">{{accessType}}</option>
            </select>
          </div>
          <div class="form-group text-right">
            <button type="submit" id="sign_in_button" class="btn btn-primary w-100">Sign In</button>
          </div>
        </form>

        <div>
          If you are not {{localUser | fullName}} or if you want to log out from
          {{localUser | fullName}}'s google account, <a href="{{classroom.newStudentPortalUrl}}student-portal/login?target={{window.location.origin}}/{{classroom.roomNum}}">click here</a>.
        </div>
        <br/>
        <!--    TODO - check if we need this  -->
        <!--    <c:if test="${not empty principalAccess}">-->
        <!--      <div>-->
        <!--        You have priority for Principal page: <a href="/principal">click here</a>.-->
        <!--      </div>-->
        <!--    </c:if>-->
      </div>
      <div class="col-6 login-right-img"></div>
    </div>
  </div>
  <app-info class="d-flex justify-content-center mt-5" style="color: #20445b"></app-info>
</div>

